import InputBox from "../../Input/Input";
import Label from "../../Label/Label";
import Modal from "../../Modal/Modal";
import React, { useState } from "react";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import Button from "../../Button/Button";
import { StripeCardNumberElementOptions } from "@stripe/stripe-js";
import { IBillingResponse } from "../../../types/types";
import AddCardBillingAddress from "./AddCardBillingAddress";
import useAuthService from "../../../auth/AuthService";

interface CardProps {
  id: string;
  title: string;
  isAuction?: boolean;
  billing_Details: IBillingResponse;
  onClick?: () => void;
  onClose?: () => void;
  isVisible?: boolean;
  isDefault?: boolean;
}

interface BillingDetails {
  name: string;
  email: string;
  phone: string;
  address: {
    line1: string;
    line2: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  };
}

const AddCard: React.FC<CardProps> = ({
  id,
  title,
  isAuction = false,
  billing_Details,
  onClick,
  onClose,
  isVisible,
  isDefault,
}) => {
  const { getUser } = useAuthService();
  const [state, setState] = useState({
    isDefault: isAuction ? true : isDefault,
    error: "",
    isLoading: false,
    showAddress: false,
    billingDetails: {
      name: billing_Details.name ? billing_Details.name : "",
      email: getUser()?.email || "",
      phone: billing_Details.phone ? billing_Details.phone : "",
      address: {
        line1: billing_Details.address_line1,
        line2: billing_Details.address_line2,
        city: billing_Details.city,
        state: billing_Details.state,
        postal_code: billing_Details.postal_code,
        country: billing_Details.country,
      },
    } as BillingDetails,
  });

  const handleCheckboxChange = () => {
    !isAuction && setState((prev) => ({ ...prev, isDefault: !prev.isDefault }));
  };

  const handleClose = () => {
    if (onClose) {
      setState((prev) => ({ ...prev, showAddress: !prev.showAddress }));
      onClose();
    }
  };

  const handleClick = () => {
    if (onClick) {
      setState((prev) => ({ ...prev, showAddress: !prev.showAddress }));
      onClick();
    }
  };

  const handlleBillingDetails = (stripeAddress: any) => {
    setState((prev) => ({
      ...prev,
      billingDetails: {
        ...prev.billingDetails,
        name: stripeAddress.name,
        address: stripeAddress.address,
        phone: stripeAddress.phone,
      },
    }));
  };

  const modalBody = (
    <div className="cart-modal modal-body bg-modalbody pt-0">
      {/* <form className="account-form text-start" onSubmit={handleSubmit}> */}
      <form className="account-form text-start">
        <div className="row mb-3">
          <Label
            className="col-12 col-form-label font-inter-400-15"
            text="Card Number"
          />
          <div className="col position-relative">
            <CardNumberElement
              options={{
                showIcon: true,
                iconStyle:
                  "solid" as StripeCardNumberElementOptions["iconStyle"],
              }}
              onChange={() => {
                setState((prev) => ({ ...prev, error: "" }));
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col mb-3">
            <Label
              className="col col-form-label font-inter-400-15"
              text="Expiration Date"
            />
            <div className="col">
              <CardExpiryElement
                onChange={() => {
                  setState((prev) => ({ ...prev, error: "" }));
                }}
              />
            </div>
          </div>
          <div className="col mb-3">
            <Label
              className="col col-form-label font-inter-400-15"
              text="Security Code"
            />
            <div className="col">
              <CardCvcElement
                onChange={() => {
                  setState((prev) => ({ ...prev, error: "" }));
                }}
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center border-top-custom pt-2 mb-3">
          <Label
            className="col col-form-label text-extra-light-purple font-inter-400-15"
            text="Default Payment Method"
          />
          <InputBox
            id="auctionNotifications"
            type="toggle"
            className="input-slider input-round"
            checked={state.isDefault}
            onChange={handleCheckboxChange}
          />
        </div>

        {state.error && <p style={{ color: "red" }}>{state.error}</p>}

        <Button
          label={
            <>
              Add Billing Address <i className="fa-solid fa-arrow-right"></i>
            </>
          }
          className="w-100 bg-light-purple mt-3 mb-3 font-inter-500-18 toRight"
          onClick={() => {
            !state.error &&
              setState((prev) => ({ ...prev, showAddress: true }));
          }}
        />
      </form>
    </div>
  );

  return (
    <>
      <Modal
        id={id}
        title={title}
        body={modalBody}
        modalBackground={"modal-bg"}
        onClose={onClose}
        isVisible={isVisible}
      />

      {state.showAddress && (
        <AddCardBillingAddress
          id={"addBillingAddress"}
          title={"Billing Address"}
          isVisible={state.showAddress}
          billingAddress={state.billingDetails}
          handleBillingDetails={handlleBillingDetails}
          isAuction={isAuction}
          onClose={handleClose}
          onBack={(error) => {
            setState((prev) => ({
              ...prev,
              showAddress: false,
              error: error as string,
            }));
          }}
          onClick={handleClick}
          addcardState={state}
        />
      )}
    </>
  );
};

export default AddCard;
